import React from 'react';
import { Instagram, Music } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/mock';

export const Footer = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <footer className="bg-navy-darker py-12">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8">
          {/* Brand */}
          <div className="text-center md:text-left">
            <h3 className="text-2xl font-bold text-gold mb-2">T-MINUS</h3>
            <p className="text-cream/70 text-sm">{t.footer.tagline}</p>
          </div>

          {/* Social Links */}
          <div className="flex gap-6">
            <a
              href="https://www.instagram.com/tminus.escaperoom/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 rounded-full bg-accent/20 border border-accent flex items-center justify-center text-gold hover:bg-accent hover:scale-110 transition-all duration-300"
            >
              <Instagram size={20} />
            </a>
            <a
              href="https://tiktok.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 rounded-full bg-accent/20 border border-accent flex items-center justify-center text-gold hover:bg-accent hover:scale-110 transition-all duration-300"
            >
              <Music size={20} />
            </a>
          </div>

          {/* Copyright */}
          <div className="text-center md:text-right">
            <p className="text-cream/50 text-sm">
              © {new Date().getFullYear()} T-MINUS. {t.footer.rights}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};